// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"779":"cb62382c","887":"73169c7e"}[chunkId] + ".chunk.css";
};